import { VabsPaymentStatus } from '@/shared/api';

export const FINAL_STATUSES = [
  VabsPaymentStatus.Declined,
  VabsPaymentStatus.Successful,
  VabsPaymentStatus.Refunded,
];
export const PROCESS_STATUSES = [
  VabsPaymentStatus.Draft,
  VabsPaymentStatus.Processing,
];
